import { useContext } from "react";

import { UploadFilesContext } from "../contexts/uploadFilesContext";
import { UploadDocumentsContextValue } from "../types";

export const useUploadFiles = (): UploadDocumentsContextValue => {
  const context = useContext(UploadFilesContext);
  if (context === undefined) {
    throw new Error(
      "useUploadFiles must be used within an UploadFilesProvider",
    );
  }
  return context;
};
